interface SVGProps {
  width?: number | string;
  height?: number | string;
  viewBox?: string;
  opacity?: number | string;
  className?: string;
}

export default function BlobSVG({
  width = 72,
  opacity = 1,
  height = 24,
  viewBox = "0 0 72 24",
  className = "",
}: SVGProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity={opacity}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M604.765 531.765C564.369 577.193 522.762 627.923 461.723 638.255C402.081 648.351 344.85 612.508 289.324 585.162C238.033 559.903 195.564 525.662 153.687 486.555C96.459 433.113 4.66383 392.268 1.01956 315.929C-2.58122 240.501 77.1411 190.782 137.5 147.479C186.673 112.202 251.819 117.362 308.629 95.2449C379.122 67.8008 433.458 -13.3086 509.252 2.74978C584.684 18.7314 628.047 101.572 663.258 170.38C695.523 233.431 709.339 304.059 698.31 372.202C688.114 435.197 646.722 484.583 604.765 531.765Z"
        fill="#1F54C5"
      />
    </svg>
  );
}
